import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
  providedIn: "root",
})
export class MessageService {
  constructor(private _snackBar: MatSnackBar) {}

  public showMessage(msg, duration) {
    this._snackBar.open(msg, "Ok", {
      duration: duration,
    });
  }
}
